import React, { Component } from "react";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import Header from "./header/Header";
import Feature from "./main/features/Feature.js";

import "./Home.scss";

const mapStateToProps = (state) => {
  console.log('mapStateToProps', state);
  return {
    isAuthenticated: state.session.isAuthenticated
  }
}

class Home extends Component {
  render() {

    return (
      <div className="container-fluid">
        <Header></Header>
        <div className="Home">
          <div className="lander container">
            <h2>Help My Mind</h2>
            <p>Providing you with the resources to help prevent a downward spiral, using grounding techniques,
          distracting games, etc.</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
            ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
            ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit
             in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
           cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
          </div>
        </div>
        <div className="layout container-fluid">
          <div className="row primary">
            <Feature name="stories" />
          </div>
          <div className="row secondary">
            <Feature name="asmr" />
          </div>
          <div className="row primary">
            <Feature name="" />
          </div>
          <div className="row secondary">
            <Feature name="feedback" />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js